// extracted by mini-css-extract-plugin
export var bodyRow = "_dl-d";
export var cardColumns = "_dl-e";
export var ellipsesOverflow = "_dl-2";
export var flatBottomCorners = "_dl-3";
export var flatTopCorners = "_dl-4";
export var headerActionsDropdown = "_dl-f";
export var headerBottomRow = "_dl-c";
export var headerTopRow = "_dl-b";
export var orderDetailsWrapper = "_dl-0";
export var orderInfoContainer = "_dl-1";
export var productDetails = "_dl-9";
export var productImage = "_dl-5";
export var responsiveTable = "_dl-8";
export var shipmentContainer = "_dl-a";
export var tableBottomLeft = "_dl-6";
export var tableBottomRight = "_dl-7";
export var trackingLink = "_dl-g";